import { MessageBar, MessageBarType } from '@fluentui/react';
import React, { PropsWithChildren, useState } from 'react';
import {
    getConfig,
    GlobalConfigProperties,
} from '../../../Common/api/ABHub/ABHubGlobalConfig';

interface IMessageBarProps extends PropsWithChildren<any> {}

export const ServiceTreeMessageBar: React.FC<IMessageBarProps> = (
    props: IMessageBarProps
) => {
    const serviceTreeNameConfig = getConfig(
        GlobalConfigProperties.UseServiceTreeIdAsLookupValue
    );

    const [showServiceTreeId, setShowServiceTreeId] = useState<boolean>(
        serviceTreeNameConfig.toLowerCase() === 'true' ? true : false
    );

    const dismissGeneralEgressMessage = () => {
        setShowServiceTreeId(false);
    };

    const getServiceTreeMessage = () => {
        return (
            <div>
                ServiceTree names are not available. ServiceTree Id's will be
                shown instead.
            </div>
        );
    };

    return (
        <div className="MessageBar-root" style={{ zIndex: 1 }}>
            {showServiceTreeId && (
                <MessageBar
                    messageBarType={MessageBarType.warning}
                    isMultiline={true}
                    onDismiss={dismissGeneralEgressMessage}
                    dismissButtonAriaLabel="Close"
                >
                    {getServiceTreeMessage()}
                </MessageBar>
            )}
        </div>
    );
};
